const MailWithWarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ style, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            style={{ fill: 'currentColor', ...style }}
            {...props}
        >
            <path
                d="M13.025 3.625L13.023 3.62656L8 7.53125L2.975 3.625L2.30625 3.10469L1.69219 3.89375L2.12344 4.22969L7.46094 8.37969C7.61444 8.49894 7.80328 8.56367 7.99766 8.56367C8.19203 8.56367 8.38088 8.49894 8.53438 8.37969L13.875 4.23125L14.3062 3.89531L13.6928 3.10701L13.6922 3.10625L13.025 3.625Z"
                fill="currentColor"
            />
            <path
                d="M14.5 2.5H1.5C1.22344 2.5 1 2.72344 1 3V13C1 13.2766 1.22344 13.5 1.5 13.5H8.53438V12.375H2.125V4.23125L1.69375 3.89531L1.69219 3.89375L2.30625 3.10469L2.975 3.625L2.97656 3.62656H13.023L13.025 3.625L13.6922 3.10625L13.6928 3.10701L13.6938 3.10625L14.3078 3.89531L13.875 4.23125V11H15V3C15 2.72344 14.7766 2.5 14.5 2.5Z"
                fill="currentColor"
            />
            <path
                d="M14.8888 14.2394L12.1804 9.55192C12.1401 9.48226 12.0704 9.44775 12.0001 9.44775C11.9298 9.44775 11.8595 9.48226 11.8197 9.55192L9.11141 14.2394C9.03133 14.3787 9.13159 14.5519 9.29175 14.5519H14.7084C14.8686 14.5519 14.9688 14.3787 14.8888 14.2394ZM11.7917 11.3748C11.7917 11.3462 11.8152 11.3228 11.8438 11.3228H12.1563C12.185 11.3228 12.2084 11.3462 12.2084 11.3748V12.5728C12.2084 12.6014 12.185 12.6248 12.1563 12.6248H11.8438C11.8152 12.6248 11.7917 12.6014 11.7917 12.5728V11.3748ZM12.0001 13.6665C11.9183 13.6648 11.8404 13.6312 11.7832 13.5728C11.726 13.5143 11.6939 13.4358 11.6939 13.354C11.6939 13.2722 11.726 13.1937 11.7832 13.1353C11.8404 13.0768 11.9183 13.0432 12.0001 13.0415C12.0819 13.0432 12.1597 13.0768 12.217 13.1353C12.2742 13.1937 12.3063 13.2722 12.3063 13.354C12.3063 13.4358 12.2742 13.5143 12.217 13.5728C12.1597 13.6312 12.0819 13.6648 12.0001 13.6665V13.6665Z"
                fill="currentColor"
            />
        </svg>
    );
};
export default MailWithWarningIcon;
